<template>
    <registration-base>
        <template #center v-if="! isLoading && (isNotFound || isExpired)">
            <period-not-found></period-not-found>
        </template>

        <template #information v-else-if="registrationLink">
            <new-info-card :registrationLink="registrationLink"></new-info-card>
        </template>

        <template #registration v-if="! isExpired && registrationLink">
            <register-or-join-card
                @join="join"
                @signup="signup"
                :period="registrationLink.period"
            ></register-or-join-card>
        </template>
    </registration-base>
</template>

<script>
import RegistrationBase from './RegistrationBase.vue'
import NewInfoCard from './components/NewInfoCard.vue'
import PeriodNotFound from './components/PeriodNotFound.vue'
import RegisterOrJoinCard from './components/RegisterOrJoinCard.vue'
import moment from '@/plugins/moment'

export default {
    components: {
        RegistrationBase,
        NewInfoCard,
        PeriodNotFound,
        RegisterOrJoinCard
    },

    data: () => ({
        registrationLink: null,
        isNotFound: false,
        isLoading: true,
    }),

    computed: {
        isExpired() {
            if (! this.registrationLink?.period.isActive) {
                return true
            }

            if (! this.registrationLink || ! this.registrationLink.validUntil) {
                return null
            }

            return moment(this.registrationLink.validUntil) < moment()
        }
    },

    methods: {
        async join() {
            await this.$apiv2.post(`registration-link/${this.$route.params.slug}/join`, {}, { loader: 'join' })

            const response = await this.$api.get('enrollment', { loader: 'join' })
            this.$store.set('enrollment/enrollments', response.data.enrollments)
            this.$store.dispatch('enrollment/selectByPeriodId', this.registrationLink.period.id)
            localStorage.setItem('lastSelectedPeriodId', this.registrationLink.period.id)
            this.$tracking.event.program.register(this.registrationLink.period.title)
            this.$router.replace({ name: 'payment' })
        },

        async signup(data) {
            const response = await this.$apiv2.post(
                `registration-link/${this.$route.params.slug}/enroll`,
                data,
                { loader: 'signup' }
            )

            this.$store.set('auth/token', response.data.token)
            this.$store.dispatch('auth/presistToken')
            window._paq.push(['trackEvent', 'Akun', 'Daftar'])

            localStorage.setItem('lastSelectedPeriodId', this.registrationLink.period.id)
            this.$tracking.event.program.register(this.registrationLink.period.title)
            this.$router.replace({ name: 'payment' })
        }
    },

    async created() {
        this.isLoading = true
        try {
            const response = await this.$apiv2.get(`registration-link/${this.$route.params.slug}`, { loader: 'registration' })

            this.registrationLink = response.data
        } catch (e) {
            if (e?.response?.status === 404) {
                this.isNotFound = true
            } else {
                throw e
            }
        }
        this.isLoading = false
    }
}
</script>
